import { fields } from '../const'

export class DrivingSchool {
  constructor(school = {}) {
    this.id = school.id
    this[fields.SLUG] = school.slug;
    this[fields.DRIVING_SCHOOL] = school.name;
    this[fields.DRIVING_SCHOOL_NUMBER] = school.number;
    this[fields.COUNT] = school.count;
    this[fields.PAID] = school.paid;
    this[fields.PCT_FROM_TOTAL_COUNT] = school.count_pct;
    this[fields.PCT_FROM_TOTAL_PAID] = school.paid_pct;
  }
}